import { WarningBanner } from 'ui/banner';
import { ScheduledBadge } from 'ui/badge';
import { IdType, ImportType } from 'modules/domains/adminApp';

import { FormFieldKey, FormState } from './types';
import { DISABLED, ENABLED, ORGANIZATION, PROJECT } from './constants';

type OverwriteWarningProps = Pick<FormState, FormFieldKey.IdType | FormFieldKey.ImportType> & {
  affectedIdCount: number;
};

export const OverwriteWarning = ({
  idType,
  importType,
  affectedIdCount,
}: OverwriteWarningProps) => {
  const projectOrOrganization = idType === IdType.Project ? PROJECT : ORGANIZATION;
  return (
    <WarningBanner isSubtle>
      This feature flag has{' '}
      <b>
        {affectedIdCount} manually {importType === ImportType.EnableFeature ? DISABLED : ENABLED}{' '}
        {projectOrOrganization} {affectedIdCount === 1 ? 'ID' : 'IDs'}
      </b>
      . If {affectedIdCount === 1 ? 'this ID matches a' : 'any of these IDs match a'}{' '}
      {projectOrOrganization} ID in the DB, the manual setting for the matching ID will be{' '}
      <ScheduledBadge>overwritten</ScheduledBadge> based on your selected import type.
    </WarningBanner>
  );
};
